import { UserEntity } from "../entity/UserEntity";
import { LocalStoreService } from "../presentation/services/LocalStoreService";

const USER_STORAGE_KEY = "nucont:user";

export class UpdateUserBrowserStorageUsecase {
    constructor() {
        this.LocalStoreService = new LocalStoreService();
    }

    async execute({
        picture,
        theme,
        dashboardTheme,
        featureFlag,
        status
    } = {}) {
        const payload = this.sanitizeInput({
            picture,
            theme,
            dashboardTheme,
            featureFlag,
            status
        });
        if (Object.keys(payload).length === 0) return null;
        const raw = this.LocalStoreService.getItem(USER_STORAGE_KEY);
        if (!raw) return null;
        const userEntity = UserEntity.restore(raw);
        if (payload.picture !== undefined)
            userEntity.updatePicture(payload.picture);
        if (payload.theme !== undefined) userEntity.updateTheme(payload.theme);
        if (payload.dashboardTheme !== undefined) {
            userEntity.updateDashboardTheme(payload.dashboardTheme);
        }
        if (payload.featureFlag !== undefined) {
            userEntity.updateFeatureFlag(
                payload.featureFlag.flag,
                payload.featureFlag.value
            );
        }
        if (payload.status !== undefined) {
            userEntity.updateStatus(payload.status);
        }
        this.LocalStoreService.setItem(
            USER_STORAGE_KEY,
            userEntity.meteorModel
        );
        return userEntity;
    }

    sanitizeInput({
        picture,
        theme,
        dashboardTheme,
        featureFlag,
        status
    } = {}) {
        const payload = {};
        if (picture !== undefined) {
            payload.picture =
                typeof picture === "string" ? picture.trim() : picture;
        }
        if (theme !== undefined) {
            payload.theme = typeof theme === "string" ? theme.trim() : theme;
        }
        if (dashboardTheme !== undefined) {
            payload.dashboardTheme =
                typeof dashboardTheme === "string"
                    ? dashboardTheme.trim()
                    : dashboardTheme;
        }
        if (featureFlag !== undefined && featureFlag !== null) {
            const rawFlag = featureFlag.flag;
            if (rawFlag !== undefined && rawFlag !== null) {
                const flag = String(rawFlag).trim();
                if (flag) {
                    payload.featureFlag = {
                        flag,
                        value: featureFlag.value
                    };
                }
            }
        }
        if (status !== undefined) {
            payload.status =
                typeof status === "string" ? status.trim() : status;
        }
        return payload;
    }
}
